import React, { Component } from 'react'
import { Mobile, Desktop, Tablet } from '../../media-queries'
import Link from 'gatsby-link'
import Mailto from 'react-mailto'
import Logo from '../../static/images/logo_white.svg'
import ArrowButton from '../shared/arrowButton'
import './footer.css'

export default class Footer extends Component {
  render() {
    const { data } = this.props
    return (
      <div
        style={{
          fontFamily: "'Libre Franklin', 'sans serif'",
          fontWeight: 300,
          fontSize: '14px',
          backgroundColor: '#F7F7F7',
        }}
      >
        <Desktop>
          <DefaultFooter
            style={{
              padding: '1rem 4rem 2rem',
            }}
            data={data}
          />
        </Desktop>
        <Tablet>
          <DefaultFooter
            style={{
              padding: '1rem 2rem',
            }}
            data={data}
          />
        </Tablet>
        <Mobile>
          <MobileFooter data={data} />
        </Mobile>
      </div>
    )
  }
}

const Column = ({ style, children }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignContent: 'flex-start',
      justifyContent: 'flex-start',
      ...style,
    }}
  >
    {children}
  </div>
)

const bold = {
  fontWeight: 600,
  fontSize: '14px',
}
const DefaultFooter = ({ data, style }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      fontSize: '12px',
      fontWeight: 300,
      ...style,
    }}
  >
    <Column>
      <div style={{ ...bold, marginBottom: 0 }}>&copy; 2018 IMRD</div>
      <Link style={{ color: '#549b54' }} to="/">
        Privacy Policy
      </Link>
      <br />
      <a style={bold} href={data.sharepointLink.url}>
        SharePoint
      </a>
      <a style={bold} href={data.eConsortLink.url}>
        eConsort
      </a>
    </Column>
    <Column>
      <div style={{ ...bold, marginBottom: '.5em' }}>IMRD Address</div>
      <div style={{ lineHeight: 1.25 }}>
        <div>{data.addressCompany}</div>
        <div>{data.addressFaculty}</div>
        <br />
        <div>{data.addressRecipient}</div>
        <div>{data.addressStreet}</div>
        <br />
        <div>{data.addressCity}</div>
        <div>{data.addressCountry}</div>
      </div>
    </Column>
    <Column>
      <div style={{ ...bold, marginBottom: '.5em' }}>Contact us:</div>
      <div style={{ lineHeight: 1.25 }}>
        <div>general information:</div>
        <Mailto
          email={data.emailGeneralInformation}
          style={{ color: '#549b54' }}
          obfuscate={true}
        >
          {data.emailGeneralInformation}
        </Mailto>
        <br />
        <br />
        <div>information on applications:</div>
        <Mailto
          email={data.emailApplications}
          style={{ color: '#549b54' }}
          obfuscate={true}
        >
          {data.emailApplications}
        </Mailto>
        <br />
        <br />
        <div>information on student matters:</div>
        <Mailto
          email={data.emailStudentMatters}
          style={{ color: '#549b54' }}
          obfuscate={true}
        >
          {data.emailStudentMatters}
        </Mailto>
      </div>
    </Column>
    <Column style={{ alignItems: 'flex-end' }}>
      <Link
        style={{ ...bold, fontSize: '14px', marginBottom: '.5em' }}
        to="/student-portal"
      >
        Student portal
      </Link>
      <Link
        style={{ ...bold, fontSize: '14px', marginBottom: '.5em' }}
        to="/universities"
      >
        IMRD Universities
      </Link>
      <Link
        style={{ ...bold, fontSize: '14px', marginBottom: '.5em' }}
        to="/student-stories"
      >
        Student Stories
      </Link>
      <Link
        style={{ ...bold, marginBottom: '.5em', textAlign: 'right' }}
        to="/learning-outcomes-and-course-content"
      >
        Learning outcomes<br />&amp; Course content
      </Link>
    </Column>
  </div>
)

const MobileFooter = ({ data }) => (
  <div
    className="footerContainer"
    style={{
      background: `url(${Logo})`,
      backgroundSize: '740px 740px',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right bottom',
    }}
  >
    <div className="linkContainer">
      <table cellSpacing="0" cellPadding="0">
        <tbody>
          <tr>
            <td>
              <Link to="/programme">Programme</Link>
            </td>
            <td>
              <Link to="/student-portal">Student portal</Link>
            </td>
          </tr>
          <tr>
            <td>
              <Link to="/application">Application</Link>
            </td>
            <td>
              <Link to="/universities">IMRD Universities</Link>
            </td>
          </tr>
          <tr>
            <td />
            <td>
              <Link to="/student-stories">Student Stories</Link>
            </td>
          </tr>
          <tr>
            <td>
              <Link to="/tuition-and-scholarships">
                Tuition &amp;<br />Scholarships
              </Link>
            </td>
            <td>
              <Link to="/learning-outcomes-and-course-content">
                Learning outcomes<br />&amp; Course content
              </Link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div className="contactContainer">
      <div>Contact us:</div>
      <div>general information:</div>
      <Mailto email={data.emailGeneralInformation} obfuscate={true}>
        {data.emailGeneralInformation}
      </Mailto>
      <div>information on applications:</div>
      <Mailto email={data.emailApplications} obfuscate={true}>
        {data.emailApplications}
      </Mailto>
      <div>information on student matters:</div>
      <Mailto email={data.emailStudentMatters} obfuscate={true}>
        {data.emailStudentMatters}
      </Mailto>
      <div className="address">
        <div>{data.addressCompany}</div>
        <div>{data.addressFaculty}</div>
        <div>{data.addressRecipient}</div>
        <div>{data.addressStreet}</div>
        <div>{data.addressCity}</div>
        <div>{data.addressCountry}</div>
      </div>
    </div>
    <table className="sharepointContainer">
      <tbody>
        <tr>
          <td />
          <td>
            <ArrowButton route={data.sharepointLink.url} text="SharePoint" />
          </td>
        </tr>
        <tr>
          <td />
          <td>
            <ArrowButton route={data.eConsortLink.url} text="eConsort" />
          </td>
        </tr>
        <tr>
          <td />
          <td />
        </tr>
      </tbody>
    </table>
    <table className="legalContainer">
      <tbody>
        <tr>
          <td>
            <Link to="/">Privacy Policy</Link>
          </td>
          <td>&copy; 2018 IMRD</td>
        </tr>
      </tbody>
    </table>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/layout/footer.js